import {TouchableOpacity, View} from "react-native";
import TextM from "@common/components/text/TextM";
import TextInputM from "@common/components/input/TextInputM";
import React, {useContext, useState} from 'react'
import {theme} from "@common/theme/theme";
import {SelectInputM} from "../SelectInputM";
import {DimensionsContext} from "@common/utils/mobileUtils";
import {IconImageM} from "@common/components/icons/IconsM";
import {ModalM} from "@common/components/modal/ModalM";
import SchoolSubjectModal from "../../../organize/school-subjects/SchoolSubjectModal";

export const SubjectSupport = ({
                                   userName,
                                   selectedSubject,
                                   prioritizedSubjects,
                                   control,
                                   errors,
                                   handleSelectSubject,
                                   field,
                                   schoolSubjects
                               }) => {
    const dimensions = useContext(DimensionsContext)
    const selectedSubjectObject = prioritizedSubjects.find(x => x.value === selectedSubject);
    const [modalVisible, setModalVisible] = useState(false);

    return <View style={{
        marginTop: 20,
        width: dimensions?.width - 40,
        justifyContent: "center",
        alignSelf: "center",
    }}>
        {prioritizedSubjects.length > 0 ? <SelectInputM options={prioritizedSubjects}
                                                        label={"Sur quelle matière souhaitez-vous concentrer la session d'essai ?"}
                                                        sliderLabel={"Sur quelle matière souhaitez-vous concentrer la session d'essai ?"}
                                                        name={"school_subject_id"}
                                                        value={selectedSubject ?? selectedSubjectObject}
                                                        labelComponent={<View style={{
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            gap: 3,
                                                        }}>
                                                            <IconImageM
                                                                uri={selectedSubject?.icon ?? selectedSubjectObject?.icon}
                                                                width={18}
                                                                style={{}}/>
                                                            <TextM fontSize={12}>
                                                                {selectedSubject?.label ?? selectedSubjectObject?.label}
                                                            </TextM>
                                                        </View>}
                                                        onSelect={(value) => {
                                                            handleSelectSubject(value)
                                                        }}
                                                        control={control}
                                                        style={{
                                                            marginBottom: 20,
                                                            width: '100%',
                                                        }}
                                                        errors={errors}
        /> : <>
            <TextM color={theme.colors.primary}
                   fontWeight={"Medium"}
                   wrap
                   fontSize={12}>
                Sur quelle matière souhaitez-vous concentrer la session d'essai ?
            </TextM>
            <TouchableOpacity
                onPress={() => {
                    setModalVisible(true);
                }}
                style={{
                    height: 50,
                    flexDirection: "row",
                    alignSelf: 'center',
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderRadius: theme.roundness,
                    paddingVertical: 10,
                    paddingHorizontal: 15,
                    marginTop: 2,
                    borderWidth: 1,
                    borderColor: theme.colors.lightMore,
                    backgroundColor: theme.colors.white,
                    width: dimensions?.width - 40,
                }}
            >
                <View style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 3,
                }}>
                    {selectedSubject?.icon && <IconImageM uri={selectedSubject?.icon} width={18} style={{}}/>}
                    <TextM color={theme.colors.primary}>
                        {selectedSubject?.label || 'Choisir une matière'}
                    </TextM>
                </View>
            </TouchableOpacity>
            <ModalM visible={modalVisible} onDismiss={() => setModalVisible(false)} style={{height: "90%"}}>
                <SchoolSubjectModal onSelectSchoolSubject={(value) => {
                    setModalVisible(false);
                    handleSelectSubject(value)
                }}
                                    options={schoolSubjects}
                                    setVisible={setModalVisible}
                />
            </ModalM>
        </>
        }
        <TextM color={theme.colors.primary}
               fontWeight={"Medium"}
               wrap
               fontSize={12}>
            En {selectedSubject?.label ?? selectedSubjectObject?.label}, quel chapitre ou
            concept {userName} aimerait-il revoir ?
        </TextM>
        <TextInputM
            placeholder="Précisez le chapitre ou concept"
            name='chapter'
            multiline={true}
            control={control}
            style={{alignSelf: 'center', width: dimensions?.width - 40, height: 94}}
            onChangeAdditional={(value) => {
                field.onChange(value)
            }}
        />
    </View>
};